import React from 'react';
import { Route, Switch } from 'react-router-dom';

import LandingPageCalls from 'flow/components/nav/landing-pages/LandingPageCalls';
import CallContactManagement from 'flow/route-components/CallContactManagement';
import CallContactCalendar from 'flow/route-components/CallContactCalendar';
import CallHistoryDetailPageV2 from 'flow/components/pbx/v2/detail-page/CallHistoryDetailPageV2';
import { routes } from 'flow/types/routes';

const PersonalCallDetailPageV2 = () => (
    <CallHistoryDetailPageV2
        pageType="personal"
        segmentContext="Personal call detail"
    />
);

const PersonalCallDetailRelatedPageV2 = () => (
    <CallHistoryDetailPageV2
        pageType="personal"
        segmentContext="Personal call detail"
        initialTab="RELATED"
    />
);

const CallsRoutes = () => (
    <Switch>
        <Route
            path={routes['calls.callRecordKey.contact']}
            component={CallContactManagement}
        />
        <Route
            path={routes['calls.callRecordKey.contactKey.calendar']}
            component={CallContactCalendar}
        />
        <Route
            path={routes['calls.callRecordKey.list']}
            component={PersonalCallDetailRelatedPageV2}
        />
        <Route
            path={routes['calls.callRecordKey.contactKey']}
            component={CallContactManagement}
        />
        <Route
            path={routes['calls.callRecordKey']}
            component={PersonalCallDetailPageV2}
        />
        <Route path="/" component={LandingPageCalls} />
    </Switch>
);

export default CallsRoutes;
